class PreferredTimeController {

  constructor(basket, availabilityService, itemService, loadingService, configService) {
    this.basket = basket;
    this.availabilityService = availabilityService;
    this.itemService = itemService;
    this.loadingService = loadingService;
    this.configService = configService;
  }

  $onInit () {
    this.item = this.itemService.getItem();
    
    let integration = this.configService.get('integration');

    if (integration) {
      this.requestAttendees = this.configService.get('integration').type === 'concept';

      if (this.requestAttendees) {
        let minimum_guests = this.item.minimum_guests || 1;
        this.guestArray = [
          1*minimum_guests,
          2*minimum_guests,
          3*minimum_guests
        ];
      }
    }


    return this.basket.promise.then(() => {
      this.isSuggestedEvent();
    });
  }

  isLoading () {
    return this.loadingService.isLoading('times')
      || !this.loadingService.isLoading('times') && !this.hasTimes();
  }

  hasTimes () {
    if (this.availabilityService.hasSingleTimes()) {
      return true;
    }

    return false;
  }

  isDisabled () {
    let times = this.availabilityService.getSingleTimes();
    return !times || (times && times.length < 2);
  }

  displayTime (startTime = null) {
    if (!startTime) {return null;}

    return startTime.substring(0, 5);
  }

  isSuggestedEvent () {
    if (this.basket.contents.suggested_event
        && this.item.type === this.basket.contents.suggested_event.type
        && this.item.id === parseInt(this.basket.contents.suggested_event.id)) {
      this.item.suggested = true;
      return true;
    }
  }

  selectTime (selectedTime) {
    let numberOfGuests = this.numberOfGuests || undefined;

    if (selectedTime.price) {
      this.item.price = selectedTime.price;
      this.item.original = selectedTime.original_price;
      this.item.end_time = selectedTime.end;
      this.itemService.setItem(this.item);
    }
    this.resetStaff();
    this.getQuantity({numberOfGuests: numberOfGuests});
  }

  updateTimes (numberOfGuests) {
    if (this.item && this.item.price && this.numberOfGuests){
      this.resetStaff();
      this.getQuantity({numberOfGuests: this.numberOfGuests});
    }
  }
}

PreferredTimeController.$inject = [ 'basket', 'availabilityService', 'itemService', 'loadingService', 'configService' ];

export default PreferredTimeController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/availability/controllers/preferred.time.controller.js